var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Box, CircularProgress, IconButton, Tab, Tabs, Tooltip } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import UploadDocumentDialog from '../../components/uiComponents/UploadDocumentDialog';
import React, { useEffect, useState } from 'react';
import CommonTable from '../../components/commonTableComponent/CommonTable';
import BacklogPagination from './components/BacklogPagination';
import TabSectionCard from './components/TabSectionCard';
import PillActionButton from '../../components/buttonComponent/PillActionButton';
import moment from 'moment-timezone';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import constants from '../../config/constants';
import { utility } from '../../utils';
import { downloadBlob } from '../../utils/commonUtilities';
import { baseColors } from '../../Themes/colors';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from '../../components/UtilityComponents/ConfirmationAndInformationPoup';
import { UploadIcon } from '../../components/icons';
import { useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import JSZip from 'jszip';
import { escapeHtml, isZipContainer, extractLegacyDocReadableText, buildEmlPreview } from './utils/documentPreviewHelpers';
import { DOCUMENT_TYPE_OPTIONS } from './utils/documentTypes';
var EXTENSION_MIME_MAP = {
    pdf: 'application/pdf',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    eml: 'message/rfc822',
};
var DocumentsManagement = function (_a) {
    var _b;
    var TxAspireOId = _a.TxAspireOId, roleType = _a.roleType, hasEditAccess = _a.hasEditAccess, onDataRefresh = _a.onDataRefresh;
    var _c = useState(), appDocuments = _c[0], setAppDocuments = _c[1];
    var _d = useState(false), isLoadingDocuments = _d[0], setIsLoadingDocuments = _d[1];
    var _f = useState({ open: false, fileUrl: null, title: 'File Preview', previewType: 'pdf', previewHtml: '' }), previewPopup = _f[0], setPreviewPopup = _f[1];
    var _g = useState(false), uploadDialogOpen = _g[0], setUploadDialogOpen = _g[1];
    var _h = useState(1), currentPage = _h[0], setCurrentPage = _h[1];
    var _j = useState(10), perPageCount = _j[0], setPerPageCount = _j[1];
    var _k = useState(null), downloadingDocumentId = _k[0], setDownloadingDocumentId = _k[1];
    var _l = useState(false), isDownloadingAll = _l[0], setIsDownloadingAll = _l[1];
    var _m = useState('all'), activeDocTab = _m[0], setActiveDocTab = _m[1];
    var userBasicInfo = useSelector(function (store) { return store.User.userData; });
    var rolePermissions = (userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.RolePermissions) || [];
    var documentMgmtPermission = rolePermissions.find(function (perm) { return perm.PermissionKey === 'APPLICATION_MANAGMENT:BACKLOG_QUEUE:APP_DOCUMENT_MGMT'; });
    var canUpdate = (documentMgmtPermission === null || documentMgmtPermission === void 0 ? void 0 : documentMgmtPermission.Update) === 1;
    var canAdd = (documentMgmtPermission === null || documentMgmtPermission === void 0 ? void 0 : documentMgmtPermission.Add) === 1;
    var getMimeTypeFromFileName = function (fileName) {
        var _a, _b, _c;
        if (!fileName)
            return 'application/octet-stream';
        var extension = (_b = (_a = fileName.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
        return (_c = EXTENSION_MIME_MAP[extension]) !== null && _c !== void 0 ? _c : 'application/octet-stream';
    };
    var isLikelyBase64 = function (value) {
        var normalizedValue = value.replace(/\s/g, '');
        if (!normalizedValue || normalizedValue.length % 4 !== 0)
            return false;
        return /^[A-Za-z0-9+/=]+$/.test(normalizedValue);
    };
    var base64ToUint8Array = function (base64Value) {
        var decodedString = window.atob(base64Value);
        var decodedBytes = new Uint8Array(decodedString.length);
        for (var i = 0; i < decodedString.length; i += 1) {
            decodedBytes[i] = decodedString.charCodeAt(i);
        }
        return decodedBytes;
    };
    var getAppDocuments = function (documentIdentifier, fileName) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, apiResponse, contentType, previewPayload, documentListPayload, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!documentIdentifier) {
                        setIsLoadingDocuments(true);
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 5, 6, 7]);
                    payload = {
                        TxAspireOId: TxAspireOId
                    };
                    if (documentIdentifier)
                        payload.DocumentIdentifier = documentIdentifier;
                    return [4, api_service.get(__assign({ endPoint: api_urls.GET_APP_DOCUMENTS, payLoad: payload, showLoader: Boolean(documentIdentifier) }, (documentIdentifier && { responseType: 'arraybuffer' })))];
                case 2:
                    apiResponse = _d.sent();
                    if (!documentIdentifier) return [3, 4];
                    contentType = (_a = apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.headers) === null || _a === void 0 ? void 0 : _a['content-type'];
                    return [4, handleDocumentDisplay(__assign(__assign({}, apiResponse), { contentType: contentType }), fileName)];
                case 3:
                    previewPayload = _d.sent();
                    return [2, previewPayload];
                case 4:
                    if (apiResponse.data && apiResponse.data.statusCode === 200) {
                        documentListPayload = (_b = apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.data) === null || _b === void 0 ? void 0 : _b.data;
                        setAppDocuments(documentListPayload || []);
                    }
                    else {
                        utility.alert((_c = apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.data) === null || _c === void 0 ? void 0 : _c.message, constants.TOAST_TYPES.ERROR);
                    }
                    return [3, 7];
                case 5:
                    error_1 = _d.sent();
                    utility.alert(error_1, constants.TOAST_TYPES.ERROR);
                    console.log('Error:', error_1);
                    return [3, 7];
                case 6:
                    if (!documentIdentifier) {
                        setIsLoadingDocuments(false);
                    }
                    return [7];
                case 7: return [2];
            }
        });
    }); };
    var handleDocumentDisplay = function (response, fileName) { return __awaiter(void 0, void 0, void 0, function () {
        var rawContentType, normalizedContentType, textDecoder, jsonString, jsonData, mimeType, arrayBufferData, trimmed, _a, meta, base64Payload, dataUriMimeType, extension, zipContainer, isDocxType, isXlsxType, isLegacyDocType, isEmlType, mammoth, result, err_1, legacyText, body, workbook, firstWorksheetName, firstWorksheet, html, emlPreview, binaryBlob, objectUrl, openInPopup, previewType;
        var _b, _c, _d;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    rawContentType = ((_b = response === null || response === void 0 ? void 0 : response.contentType) !== null && _b !== void 0 ? _b : '').toLowerCase();
                    normalizedContentType = rawContentType.split(';')[0] || '';
                    if (normalizedContentType.includes('application/json')) {
                        textDecoder = new TextDecoder("utf-8");
                        jsonString = textDecoder.decode(response.data);
                        jsonData = JSON.parse(jsonString);
                        setAppDocuments(jsonData || []);
                        utility.alert(jsonData === null || jsonData === void 0 ? void 0 : jsonData.message);
                        return [2];
                    }
                    mimeType = normalizedContentType && normalizedContentType !== 'application/octet-stream'
                        ? normalizedContentType
                        : getMimeTypeFromFileName(fileName);
                    if (response.data instanceof ArrayBuffer) {
                        arrayBufferData = response.data;
                    }
                    else if (typeof response.data === 'string') {
                        trimmed = response.data.trim();
                        if (trimmed.startsWith('data:')) {
                            _a = trimmed.split(',', 2), meta = _a[0], base64Payload = _a[1];
                            dataUriMimeType = meta.replace('data:', '').replace(';base64', '');
                            if (dataUriMimeType) {
                                mimeType = dataUriMimeType;
                            }
                            arrayBufferData = base64ToUint8Array(base64Payload !== null && base64Payload !== void 0 ? base64Payload : '').buffer;
                        }
                        else if (isLikelyBase64(trimmed)) {
                            arrayBufferData = base64ToUint8Array(trimmed).buffer;
                        }
                    }
                    if (!arrayBufferData) {
                        utility.alert('Unable to process document response.', constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    extension = (_d = (_c = fileName === null || fileName === void 0 ? void 0 : fileName.split('.').pop()) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== null && _d !== void 0 ? _d : '';
                    zipContainer = isZipContainer(arrayBufferData);
                    isDocxType = mimeType.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document')
                        || extension === 'docx';
                    isXlsxType = mimeType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
                        mimeType.includes('application/vnd.ms-excel');
                    isLegacyDocType = (mimeType.includes('application/msword') || mimeType.includes('application/vnd.ms-word') || extension === 'doc')
                        && !zipContainer;
                    isEmlType = mimeType.includes('message/rfc822') || mimeType.includes('application/vnd.ms-outlook') || extension === 'eml';
                    if (!(isDocxType || (mimeType.includes('application/msword') && zipContainer))) return [3, 5];
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 4, , 5]);
                    return [4, import('mammoth')];
                case 2:
                    mammoth = _f.sent();
                    return [4, mammoth.convertToHtml({ arrayBuffer: arrayBufferData })];
                case 3:
                    result = _f.sent();
                    return [2, {
                            openInPopup: true,
                            previewType: 'docx',
                            previewHtml: result.value,
                        }];
                case 4:
                    err_1 = _f.sent();
                    utility.alert('Unable to preview DOCX file.', constants.TOAST_TYPES.ERROR);
                    return [2];
                case 5:
                    if (isLegacyDocType) {
                        legacyText = extractLegacyDocReadableText(arrayBufferData);
                        body = legacyText || 'Unable to extract readable content from this legacy Word document.';
                        return [2, {
                                openInPopup: true,
                                previewType: 'text',
                                previewHtml: "<pre style=\"white-space: pre-wrap; word-break: break-word; font-family: monospace; font-size: 12px; line-height: 1.6;\">".concat(escapeHtml(body), "</pre>"),
                            }];
                    }
                    if (isXlsxType) {
                        try {
                            workbook = XLSX.read(arrayBufferData, { type: 'array' });
                            firstWorksheetName = workbook.SheetNames[0];
                            firstWorksheet = firstWorksheetName ? workbook.Sheets[firstWorksheetName] : undefined;
                            html = firstWorksheet
                                ? XLSX.utils.sheet_to_html(firstWorksheet)
                                : '<p>No worksheet available for preview.</p>';
                            return [2, {
                                    openInPopup: true,
                                    previewType: 'xlsx',
                                    previewHtml: html,
                                }];
                        }
                        catch (err) {
                            utility.alert('Unable to preview XLSX file.', constants.TOAST_TYPES.ERROR);
                            return [2];
                        }
                    }
                    if (isEmlType) {
                        emlPreview = buildEmlPreview(arrayBufferData, fileName);
                        return [2, {
                                openInPopup: true,
                                previewType: emlPreview.previewType,
                                previewHtml: emlPreview.previewHtml,
                                attachments: emlPreview.attachments,
                            }];
                    }
                    binaryBlob = new Blob([arrayBufferData], { type: mimeType });
                    objectUrl = URL.createObjectURL(binaryBlob);
                    openInPopup = mimeType.includes('application/pdf') || mimeType.startsWith('image/');
                    previewType = mimeType.startsWith('image/') ? 'image' : 'pdf';
                    return [2, {
                            url: objectUrl,
                            openInPopup: openInPopup,
                            previewType: previewType,
                        }];
            }
        });
    }); };
    useEffect(function () {
        if (TxAspireOId) {
            getAppDocuments();
        }
    }, [TxAspireOId]);
    useEffect(function () {
        setCurrentPage(1);
    }, [appDocuments]);
    useEffect(function () {
        setCurrentPage(1);
    }, [activeDocTab]);
    var formatAppDocuments = function (appDocs) {
        if (appDocs === void 0) { appDocs = []; }
        var formatDate = function (date) {
            return date ? moment.utc(date).format('MM-DD-YYYY hh:mm:ss A') : '--';
        };
        return appDocs.map(function (item) { return (__assign(__assign({}, item), { CreatedDate: formatDate(item.CreatedDate), LastChangeDateTime: formatDate(item.LastChangeDateTime) })); });
    };
    var handleUploadDocument = function (files, docType, onSuccess, onError) { return __awaiter(void 0, void 0, void 0, function () {
        var formData_1, response, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    if (!files || files.length === 0 || !TxAspireOId) {
                        utility.alert('Invalid files or application ID', constants.TOAST_TYPES.ERROR);
                        onError();
                        return [2];
                    }
                    formData_1 = new FormData();
                    files.forEach(function (file, index) {
                        formData_1.append("Docs[".concat(index, "][File]"), file);
                        formData_1.append("Docs[".concat(index, "][DocType]"), docType);
                    });
                    formData_1.append('ContractAspireOId', TxAspireOId);
                    return [4, api_service.post({
                            endPoint: api_urls.UPLOAD_APP_DOCUMENT,
                            payLoad: formData_1,
                            headerType: api_service.ContentHeaders.FormData,
                            showLoader: false,
                        })];
                case 1:
                    response = _b.sent();
                    if (response.data && response.data.statusCode === 200) {
                        getAppDocuments();
                        onSuccess();
                    }
                    else {
                        utility.alert((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.message, constants.TOAST_TYPES.ERROR);
                        onError();
                    }
                    return [3, 3];
                case 2:
                    error_2 = _b.sent();
                    utility.alert(error_2, constants.TOAST_TYPES.ERROR);
                    console.log('Error uploading document:', error_2);
                    onError();
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var handleRowClick = function (rowData) { return __awaiter(void 0, void 0, void 0, function () {
        var title, previewPayload, fileUrl_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!rowData.DocumentIdentifier) return [3, 2];
                    title = (rowData === null || rowData === void 0 ? void 0 : rowData.DocumentName) || (rowData === null || rowData === void 0 ? void 0 : rowData.FileName) || 'Document Preview';
                    return [4, getAppDocuments(rowData.DocumentIdentifier, rowData.FileName)];
                case 1:
                    previewPayload = _b.sent();
                    if (!previewPayload)
                        return [2];
                    if (previewPayload.openInPopup && (previewPayload.previewType === 'docx' || previewPayload.previewType === 'xlsx' || previewPayload.previewType === 'text' || previewPayload.previewType === 'html')) {
                        setPreviewPopup({
                            open: true,
                            fileUrl: null,
                            title: title,
                            previewType: previewPayload.previewType,
                            previewHtml: (_a = previewPayload.previewHtml) !== null && _a !== void 0 ? _a : '',
                            attachments: previewPayload.attachments,
                        });
                        return [2];
                    }
                    fileUrl_1 = previewPayload.url;
                    if (!fileUrl_1)
                        return [2];
                    if (previewPayload.openInPopup) {
                        setPreviewPopup({
                            open: true,
                            fileUrl: fileUrl_1,
                            title: title,
                            previewType: previewPayload.previewType,
                            previewHtml: '',
                        });
                        return [2];
                    }
                    window.open(fileUrl_1, '_blank', 'noopener,noreferrer');
                    setTimeout(function () { return URL.revokeObjectURL(fileUrl_1); }, 30000);
                    _b.label = 2;
                case 2: return [2];
            }
        });
    }); };
    var fetchDocumentBinary = function (documentIdentifier, fileName) { return __awaiter(void 0, void 0, void 0, function () {
        var apiResponse, rawContentType, contentType, textDecoder, jsonString, jsonData, mimeType, error_3;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: api_urls.GET_APP_DOCUMENTS,
                            payLoad: { TxAspireOId: TxAspireOId, DocumentIdentifier: documentIdentifier },
                            showLoader: false,
                            responseType: 'arraybuffer',
                        })];
                case 1:
                    apiResponse = _c.sent();
                    rawContentType = (_a = apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.headers) === null || _a === void 0 ? void 0 : _a['content-type'];
                    contentType = String(Array.isArray(rawContentType) ? (_b = rawContentType[0]) !== null && _b !== void 0 ? _b : '' : rawContentType !== null && rawContentType !== void 0 ? rawContentType : '')
                        .toLowerCase()
                        .split(';')[0];
                    if (contentType.includes('application/json') && apiResponse.data instanceof ArrayBuffer) {
                        textDecoder = new TextDecoder('utf-8');
                        jsonString = textDecoder.decode(apiResponse.data);
                        jsonData = JSON.parse(jsonString);
                        utility.alert((jsonData === null || jsonData === void 0 ? void 0 : jsonData.message) || "Unable to download ".concat(fileName !== null && fileName !== void 0 ? fileName : 'document', "."), constants.TOAST_TYPES.ERROR);
                        return [2, null];
                    }
                    if (!(apiResponse.data instanceof ArrayBuffer)) {
                        utility.alert("Unable to download ".concat(fileName !== null && fileName !== void 0 ? fileName : 'document', "."), constants.TOAST_TYPES.ERROR);
                        return [2, null];
                    }
                    mimeType = contentType && contentType !== 'application/octet-stream'
                        ? contentType
                        : getMimeTypeFromFileName(fileName);
                    return [2, { data: apiResponse.data, mimeType: mimeType }];
                case 2:
                    error_3 = _c.sent();
                    utility.alert(error_3, constants.TOAST_TYPES.ERROR);
                    return [2, null];
                case 3: return [2];
            }
        });
    }); };
    var handleDownloadDocument = function (rowData) { return __awaiter(void 0, void 0, void 0, function () {
        var fileName, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(rowData === null || rowData === void 0 ? void 0 : rowData.DocumentIdentifier) || downloadingDocumentId)
                        return [2];
                    fileName = (rowData === null || rowData === void 0 ? void 0 : rowData.FileName) || (rowData === null || rowData === void 0 ? void 0 : rowData.DocumentName) || 'document';
                    setDownloadingDocumentId(rowData.DocumentIdentifier);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4, fetchDocumentBinary(rowData.DocumentIdentifier, fileName)];
                case 2:
                    result = _a.sent();
                    if (!result)
                        return [2];
                    downloadBlob(new Blob([result.data], { type: result.mimeType }), fileName);
                    return [3, 4];
                case 3:
                    setDownloadingDocumentId(null);
                    return [7];
                case 4: return [2];
            }
        });
    }); };
    var handleDownloadAllDocuments = function () { return __awaiter(void 0, void 0, void 0, function () {
        var zip, usedFileNames, downloadedCount, _i, formattedDocs_1, doc, fileName, result, uniqueFileName, suffix, dotIndex, zipBlob, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isDownloadingAll || formattedDocs.length === 0)
                        return [2];
                    setIsDownloadingAll(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, 8, 9]);
                    zip = new JSZip();
                    usedFileNames = new Set();
                    downloadedCount = 0;
                    _i = 0, formattedDocs_1 = formattedDocs;
                    _a.label = 2;
                case 2:
                    if (!(_i < formattedDocs_1.length)) return [3, 5];
                    doc = formattedDocs_1[_i];
                    if (!doc.DocumentIdentifier)
                        return [3, 4];
                    fileName = doc.FileName || doc.DocumentName || "document-".concat(doc.DocumentIdentifier);
                    return [4, fetchDocumentBinary(doc.DocumentIdentifier, fileName)];
                case 3:
                    result = _a.sent();
                    if (!result)
                        return [3, 4];
                    uniqueFileName = fileName;
                    suffix = 1;
                    while (usedFileNames.has(uniqueFileName)) {
                        dotIndex = fileName.lastIndexOf('.');
                        uniqueFileName = dotIndex === -1
                            ? "".concat(fileName, " (").concat(suffix, ")")
                            : "".concat(fileName.slice(0, dotIndex), " (").concat(suffix, ")").concat(fileName.slice(dotIndex));
                        suffix += 1;
                    }
                    usedFileNames.add(uniqueFileName);
                    zip.file(uniqueFileName, result.data);
                    downloadedCount += 1;
                    _a.label = 4;
                case 4:
                    _i++;
                    return [3, 2];
                case 5:
                    if (downloadedCount === 0) {
                        utility.alert('Unable to download documents.', constants.TOAST_TYPES.ERROR);
                        return [2];
                    }
                    return [4, zip.generateAsync({ type: 'blob' })];
                case 6:
                    zipBlob = _a.sent();
                    downloadBlob(zipBlob, "".concat(TxAspireOId || 'application', "-documents.zip"));
                    return [3, 9];
                case 7:
                    error_4 = _a.sent();
                    utility.alert('Unable to download all documents.', constants.TOAST_TYPES.ERROR);
                    return [3, 9];
                case 8:
                    setIsDownloadingAll(false);
                    return [7];
                case 9: return [2];
            }
        });
    }); };
    var columns = [
        { key: 'FileName', header: 'File Name', sortable: true },
        { key: 'FileSize', header: 'Size', sortable: true },
        { key: 'DocumentType', header: 'Document Type', sortable: true },
        { key: 'LastChangeOperator', header: 'Modified By' },
        { key: 'LastChangeDateTime', header: 'Modified Date' },
        { key: 'CreatedDate', header: 'Created Date' },
        {
            key: 'DocumentIdentifier',
            header: 'Actions',
            align: 'center',
            sticky: 'right',
            render: function (_value, row) { return (React.createElement(React.Fragment, null,
                React.createElement(Tooltip, { title: "View", placement: "top", arrow: true },
                    React.createElement("span", null,
                        React.createElement(IconButton, { size: "small", onClick: function (e) { e.stopPropagation(); handleRowClick(row); } },
                            React.createElement(VisibilityOutlinedIcon, { fontSize: "small" })))),
                React.createElement(Tooltip, { title: "Download", placement: "top", arrow: true },
                    React.createElement("span", null,
                        React.createElement(IconButton, { size: "small", disabled: downloadingDocumentId === row.DocumentIdentifier, onClick: function (e) { e.stopPropagation(); handleDownloadDocument(row); } }, downloadingDocumentId === row.DocumentIdentifier ? (React.createElement(CircularProgress, { size: 16 })) : (React.createElement(FileDownloadOutlinedIcon, { fontSize: "small" }))))))); },
        },
    ];
    var formattedDocs = formatAppDocuments(appDocuments || []);
    var isEmailDocument = function (doc) { var _a; return ((_a = doc === null || doc === void 0 ? void 0 : doc.DocumentType) !== null && _a !== void 0 ? _a : '').toLowerCase().includes('email'); };
    var emailDocs = formattedDocs.filter(isEmailDocument);
    var nonEmailDocs = formattedDocs.filter(function (doc) { return !isEmailDocument(doc); });
    var tabFilteredDocs = activeDocTab === 'email'
        ? emailDocs
        : activeDocTab === 'documents'
            ? nonEmailDocs
            : formattedDocs;
    var totalCount = tabFilteredDocs.length;
    var pagedDocs = tabFilteredDocs.slice((currentPage - 1) * perPageCount, currentPage * perPageCount);
    var uploadButton = (canAdd || canUpdate) ? (React.createElement(PillActionButton, { icon: React.createElement(UploadIcon, { sx: { fontSize: 18 } }), label: "Upload Document", onClick: function () { return setUploadDialogOpen(true); }, hoverOnly: true, bgColor: baseColors.bluePreset[60], borderColor: baseColors.bluePreset[70], textColor: baseColors.bluePreset[80] })) : null;
    var downloadAllButton = (React.createElement(PillActionButton, { icon: isDownloadingAll ? React.createElement(CircularProgress, { size: 16 }) : React.createElement(FileDownloadOutlinedIcon, { sx: { fontSize: 18 } }), label: isDownloadingAll ? 'Downloading...' : 'Download All', disabled: isDownloadingAll || totalCount === 0, onClick: handleDownloadAllDocuments, hoverOnly: true, bgColor: baseColors.successPreset[60], borderColor: baseColors.successPreset[70], textColor: baseColors.successPreset[80] }));
    var headerActions = (React.createElement(Box, { sx: { display: 'flex', gap: 1.5 } },
        downloadAllButton,
        uploadButton));
    return (React.createElement(Box, null,
        React.createElement(TabSectionCard, { title: "Documents Management", headerActions: headerActions, dense: true },
            React.createElement(Tabs, { value: activeDocTab, onChange: function (_e, nextTab) { return setActiveDocTab(nextTab); }, sx: {
                    minHeight: 28,
                    mb: 0.75,
                    borderBottom: "1px solid ".concat(baseColors.greyPreset[40]),
                    '& .MuiTabs-indicator': { backgroundColor: baseColors.successPreset[30] },
                } },
                React.createElement(Tab, { value: "all", label: "All (".concat(formattedDocs.length, ")"), sx: { textTransform: 'none', fontSize: 13, fontWeight: 600, minHeight: 28, py: 0.5, '&.Mui-selected': { color: baseColors.successPreset[30] } } }),
                React.createElement(Tab, { value: "documents", label: "Documents (".concat(nonEmailDocs.length, ")"), sx: { textTransform: 'none', fontSize: 13, fontWeight: 600, minHeight: 28, py: 0.5, '&.Mui-selected': { color: baseColors.successPreset[30] } } }),
                React.createElement(Tab, { value: "email", label: "Email (".concat(emailDocs.length, ")"), sx: { textTransform: 'none', fontSize: 13, fontWeight: 600, minHeight: 28, py: 0.5, '&.Mui-selected': { color: baseColors.successPreset[30] } } })),
            React.createElement(CommonTable, { columns: columns, data: pagedDocs, loading: isLoadingDocuments, moduleName: "Documents Management", emptyMessage: activeDocTab === 'email' ? 'No email documents found.' : 'No documents found.', onRowClick: handleRowClick, keyExtractor: function (row, index) { var _a; return (_a = row.DocumentIdentifier) !== null && _a !== void 0 ? _a : index; }, paginationSlot: React.createElement(Box, { sx: { pl: '16px', pr: '16px' } },
                    React.createElement(BacklogPagination, { currentPage: currentPage, perPageCount: perPageCount, totalCount: totalCount, onPageChange: setCurrentPage, onPerPageChange: function (count) { setPerPageCount(count); setCurrentPage(1); } })) })),
        React.createElement(UploadDocumentDialog, { open: uploadDialogOpen, onClose: function () { return setUploadDialogOpen(false); }, onUpload: handleUploadDocument, documentTypes: DOCUMENT_TYPE_OPTIONS, allowedExtensions: ['docx', 'xlsx', 'pdf', 'jpeg', 'jpg'], dialogTitle: "Upload Documents", uploadButtonLabel: "Upload Documents", cancelButtonLabel: "Cancel", successTitle: "Upload Successful!", successMessage: "Your documents have been uploaded successfully.", multiple: false }),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.BINARY_FILE_PREVIEW, titleText: (_b = previewPopup.title) !== null && _b !== void 0 ? _b : 'File Preview', subTitleText: "", message: '', acceptBtnText: "Yes", open: previewPopup.open, acceptCallBack: function () { }, closePdf: function () {
                if (previewPopup.fileUrl) {
                    URL.revokeObjectURL(previewPopup.fileUrl);
                }
                setPreviewPopup({ open: false, fileUrl: null, title: 'File Preview', previewType: 'pdf', previewHtml: '' });
            }, previewType: previewPopup.previewType, previewHtml: previewPopup.previewHtml, attachments: previewPopup.attachments, enablePreviewZoom: true, fileUrl: previewPopup.fileUrl })));
};
export default DocumentsManagement;
